/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * Subscription API
 * Внешнее апи для управления чатом
 * OpenAPI spec version: 1.0.0
 */
import { faker } from '@faker-js/faker';

import { HttpResponse, delay, http } from 'msw';

import { createSubscriptionsInstance } from '../../api-instance';
import type { BodyType } from '../../api-instance';
export interface SubscriptionCreate {
  /** ID тарифи для оформления подписки */
  tariff_id: number;
  /** Интервал действия подписки в месяцах */
  interval: number;
  /** Тип канала комуникации */
  channel_type: string;
}

export interface SubscriptionRenewal {
  /** ID тарифи для оформления подписки */
  tariff_id: number;
  /** Интервал действия подписки в месяцах */
  interval: number;
  /** Тип канала комуникации */
  channel_type: string;
}

export interface Order {
  /** Уникальный идентификатор заказа */
  order_id: string;
  /** Уникальный идентификатор подписки */
  subscription_id: string;
  /** Тип тарифного плана подписки */
  tariff: string;
  /** Тип протокола */
  protocol: string;
  /** Срок дейсдвия подписки */
  interval: number;
  /** Сумма заказа */
  amount: number;
  /** Дата начала заказа */
  date: string;
}

export interface OrderConfirm {
  /** Уникальный идентификатор заказа */
  order_id: string;
  /** EMAIL пользователя */
  email: string;
  /** Способ оплаты заказа */
  payment_method?: 'card' | 'bank_invoice';
}

export interface SubscriptionResponse {
  /** Уникальный идентификатор подписки */
  id: string;
  /** Идентификатор аккаунта */
  account_id: string;
  /** Тип тарифного плана подписки */
  tariff: string;
  /** Дата окончания подписки */
  end_date: string;
  prolongation: boolean;
  price: number;
  discount?: number;
  /** Лимит уникальных чатов за текущий период */
  chat_limit?: number | null;
  /** Использовано уникальных чатов в текущем периоде */
  used_chats?: number | null;
  /** Дата окончания текущего периода лимита */
  quota_period_end?: string | null;
}

export interface Subscription {
  /** Уникальный идентификатор подписки */
  id: string;
  /** Идентификатор аккаунта */
  account_id: string;
  /** Тип тарифного плана подписки */
  tariff: string;
  /** Дата начала подписки */
  start_date: string;
  interval: number;
  /** Дата окончания подписки */
  end_date: string;
  /** Флаг использования бустера */
  booster_used?: boolean;
}

export interface ProblemDetails {
  type: string;
  title: string;
  detail: string;
  status: number;
}

export interface TariffGridItem {
  tariff_info: TariffInfo;
  tariff_grid_plan: TariffPlan[];
}

export interface TariffInfo {
  tariff_id: number;
  name: string;
  price: number;
  can_write_first: boolean;
  dialog_count: string;
  group_chats_enabled: boolean;
  priority_technical_support: boolean;
}

export interface PaymentResponse {
  /** Ссылка для перенаправления на оплату */
  paymentLink: string;
  /** Идентификатор счёта в банке при оплате по расчётному счёту */
  invoiceId?: string;
}

export interface TariffPlan {
  interval: number;
  discount: number;
  discount_price: number;
  full_price: number;
  final_price: number;
}

export type GetSubscriptionByChannelIDParams = {
  /**
   * id канала
   */
  channel_id: string;
};

export type CreateSubscriptionParams = {
  /**
   * Account Id uuid
   */
  account_id: string;
};

export type SubscriptionRenewalParams = {
  /**
   * Channel id uuid
   */
  channel_id: string;
  /**
   * Account Id uuid
   */
  account_id: string;
};

export type GetTariffGridParams = {
  /**
   * протокол для подключения
   */
  protocol: string;
};

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary Получения подписки по id кагала комуникации
 */
export const getSubscriptionByChannelID = (
  params: GetSubscriptionByChannelIDParams,
  options?: SecondParameter<typeof createSubscriptionsInstance>
) => {
  return createSubscriptionsInstance<SubscriptionResponse>(
    { url: `/api/v1/subscription`, method: 'GET', params },
    options
  );
};

/**
 * @summary Оформление подписки
 */
export const createSubscription = (
  subscriptionCreate: BodyType<SubscriptionCreate>,
  params: CreateSubscriptionParams,
  options?: SecondParameter<typeof createSubscriptionsInstance>
) => {
  return createSubscriptionsInstance<Order>(
    {
      url: `/api/v1/subscription`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: subscriptionCreate,
      params,
    },
    options
  );
};

/**
 * @summary Продление подписки
 */
export const subscriptionRenewal = (
  subscriptionRenewal: BodyType<SubscriptionRenewal>,
  params: SubscriptionRenewalParams,
  options?: SecondParameter<typeof createSubscriptionsInstance>
) => {
  return createSubscriptionsInstance<Order>(
    {
      url: `/api/v1/subscription/renewal`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: subscriptionRenewal,
      params,
    },
    options
  );
};

/**
 * @summary Подтверждение заказа и возврат ссылки на оплату
 */
export const orderConfirm = (
  orderConfirm: BodyType<OrderConfirm>,
  options?: SecondParameter<typeof createSubscriptionsInstance>
) => {
  return createSubscriptionsInstance<PaymentResponse>(
    {
      url: `/api/v1/confirm`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: orderConfirm,
    },
    options
  );
};

/**
 * @summary Получение тарифной сетки
 */
export const getTariffGrid = (
  params: GetTariffGridParams,
  options?: SecondParameter<typeof createSubscriptionsInstance>
) => {
  return createSubscriptionsInstance<TariffGridItem[]>(
    { url: `/api/v1/tariffgrid`, method: 'GET', params },
    options
  );
};

export type GetSubscriptionByChannelIDResult = NonNullable<
  Awaited<ReturnType<typeof getSubscriptionByChannelID>>
>;
export type CreateSubscriptionResult = NonNullable<
  Awaited<ReturnType<typeof createSubscription>>
>;
export type SubscriptionRenewalResult = NonNullable<
  Awaited<ReturnType<typeof subscriptionRenewal>>
>;
export type OrderConfirmResult = NonNullable<
  Awaited<ReturnType<typeof orderConfirm>>
>;
export type GetTariffGridResult = NonNullable<
  Awaited<ReturnType<typeof getTariffGrid>>
>;

export const getGetSubscriptionByChannelIDResponseMock = (
  overrideResponse: Partial<SubscriptionResponse> = {}
): SubscriptionResponse => ({
  id: faker.string.uuid(),
  account_id: faker.string.uuid(),
  tariff: faker.string.alpha(20),
  end_date: `${faker.date.past().toISOString().split('.')[0]}Z`,
  prolongation: faker.datatype.boolean(),
  price: faker.number.float(),
  discount: faker.helpers.arrayElement([faker.number.float(), undefined]),
  ...overrideResponse,
});

export const getCreateSubscriptionResponseMock = (
  overrideResponse: Partial<Order> = {}
): Order => ({
  order_id: faker.string.uuid(),
  subscription_id: faker.string.uuid(),
  tariff: faker.string.alpha(20),
  protocol: faker.string.alpha(20),
  interval: faker.number.int({ min: undefined, max: undefined }),
  amount: faker.number.float(),
  date: `${faker.date.past().toISOString().split('.')[0]}Z`,
  ...overrideResponse,
});

export const getSubscriptionRenewalResponseMock = (
  overrideResponse: Partial<Order> = {}
): Order => ({
  order_id: faker.string.uuid(),
  subscription_id: faker.string.uuid(),
  tariff: faker.string.alpha(20),
  protocol: faker.string.alpha(20),
  interval: faker.number.int({ min: undefined, max: undefined }),
  amount: faker.number.float(),
  date: `${faker.date.past().toISOString().split('.')[0]}Z`,
  ...overrideResponse,
});

export const getOrderConfirmResponseMock = (
  overrideResponse: Partial<PaymentResponse> = {}
): PaymentResponse => ({
  paymentLink: faker.string.alpha(20),
  ...overrideResponse,
});

export const getGetTariffGridResponseMock = (): TariffGridItem[] =>
  Array.from(
    { length: faker.number.int({ min: 1, max: 10 }) },
    (_, i) => i + 1
  ).map(() => ({
    tariff_info: {
      tariff_id: faker.number.int({ min: undefined, max: undefined }),
      name: faker.string.alpha(20),
      price: faker.number.float(),
      can_write_first: faker.datatype.boolean(),
      dialog_count: faker.string.alpha(20),
      group_chats_enabled: faker.datatype.boolean(),
      priority_technical_support: faker.datatype.boolean(),
    },
    tariff_grid_plan: Array.from(
      { length: faker.number.int({ min: 1, max: 10 }) },
      (_, i) => i + 1
    ).map(() => ({
      interval: faker.number.int({ min: undefined, max: undefined }),
      discount: faker.number.float(),
      discount_price: faker.number.float(),
      full_price: faker.number.float(),
      final_price: faker.number.float(),
    })),
  }));

export const getGetSubscriptionByChannelIDMockHandler = (
  overrideResponse?:
    | SubscriptionResponse
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0]
      ) => Promise<SubscriptionResponse> | SubscriptionResponse)
) => {
  return http.get('*/api/v1/subscription', async (info) => {
    await delay(1000);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getGetSubscriptionByChannelIDResponseMock()
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } }
    );
  });
};

export const getCreateSubscriptionMockHandler = (
  overrideResponse?:
    | Order
    | ((
        info: Parameters<Parameters<typeof http.post>[1]>[0]
      ) => Promise<Order> | Order)
) => {
  return http.post('*/api/v1/subscription', async (info) => {
    await delay(1000);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getCreateSubscriptionResponseMock()
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } }
    );
  });
};

export const getSubscriptionRenewalMockHandler = (
  overrideResponse?:
    | Order
    | ((
        info: Parameters<Parameters<typeof http.post>[1]>[0]
      ) => Promise<Order> | Order)
) => {
  return http.post('*/api/v1/subscription/renewal', async (info) => {
    await delay(1000);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getSubscriptionRenewalResponseMock()
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } }
    );
  });
};

export const getOrderConfirmMockHandler = (
  overrideResponse?:
    | PaymentResponse
    | ((
        info: Parameters<Parameters<typeof http.post>[1]>[0]
      ) => Promise<PaymentResponse> | PaymentResponse)
) => {
  return http.post('*/api/v1/confirm', async (info) => {
    await delay(1000);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getOrderConfirmResponseMock()
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } }
    );
  });
};

export const getGetTariffGridMockHandler = (
  overrideResponse?:
    | TariffGridItem[]
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0]
      ) => Promise<TariffGridItem[]> | TariffGridItem[])
) => {
  return http.get('*/api/v1/tariffgrid', async (info) => {
    await delay(1000);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getGetTariffGridResponseMock()
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } }
    );
  });
};
export const getSubscriptionAPIMock = () => [
  getGetSubscriptionByChannelIDMockHandler(),
  getCreateSubscriptionMockHandler(),
  getSubscriptionRenewalMockHandler(),
  getOrderConfirmMockHandler(),
  getGetTariffGridMockHandler(),
];
